import React, { PropsWithChildren } from 'react';

import Analytics, { AnalyticsInstance } from 'analytics';

const AnalyticsContext = React.createContext<AnalyticsInstance>(undefined!);
AnalyticsContext.displayName = 'Analytics';

type AnalyticsProviderProps = PropsWithChildren<{
    app: string;
    version: string;
    registerPlugins?: (includeClientPlugins: boolean) => any[];
}>;

const AnalyticsProvider = ({
    children,
    app,
    version = '1.0.0',
    registerPlugins = () => [],
}: AnalyticsProviderProps) => {
    const analytics = React.useMemo(() => {
        return Analytics({
            app,
            version,
            debug: process.env.NODE_ENV === 'development',
            plugins: registerPlugins(
                typeof window !== 'undefined' &&
                    (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development'),
            ),
        });
    }, []);

    return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

export { AnalyticsProvider, AnalyticsContext };
